module.exports = __webpack_public_path__ + "static/media/bumppyloginpageimgtwo.1aab7183.png";